/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  stock: number;
};

const SOLD_OUT_COUNT = 0;
const LOW_STOCK_UPPER_COUNT = 10;

export const NoteLabel: FcWithoutChildren<Props> = (props) => {
  const { stock } = props;

  // TODO: 多言語対応 https://github.com/balus-co-ltd/spwn/issues/11159
  // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
  if (stock === SOLD_OUT_COUNT) return <span css={soldOutStyle}>売り切れ</span>;

  // TODO: 多言語対応 https://github.com/balus-co-ltd/spwn/issues/11159
  if (stock < LOW_STOCK_UPPER_COUNT)
    // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
    return <span css={lowStockStyle}>残りわずか</span>;

  return null;
};

const commonStyle = css`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

const lowStockStyle = css`
  color: #f56565;
  ${commonStyle}
`;

const soldOutStyle = css`
  color: #a3a3a3;
  ${commonStyle}
`;
